import React from "react";
import { Check } from "lucide-react";
import { IMG, MAST_FEATURES, MAST_USE_CASES } from "@/lib/content";

export default function Mast() {
  return (
    <section
      id="kameramast"
      data-testid="mast-section"
      className="relative bg-white py-24 md:py-32"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16 items-start">
          <div className="lg:col-span-7">
            <p className="tag-line text-xs font-mono-tech uppercase tracking-[0.25em] text-[#0055A4] mb-6">
              Produkt · Kameramast
            </p>
            <h2
              data-testid="mast-headline"
              className="font-display text-3xl sm:text-4xl lg:text-5xl font-semibold text-slate-900 tracking-tight"
            >
              Der Xortec Kameramast.
              <br />
              <span className="text-slate-500">
                Tragwerk für professionelle Sicherheit.
              </span>
            </h2>
            <p className="mt-6 text-slate-600 text-base sm:text-lg leading-relaxed max-w-2xl">
              Aluminium statt Stahl. Wartungsfreundlich statt unzugänglich.
              Modular statt starr. Der Xortec Kameramast ist die Basis unserer
              integrierten Sicherheitsinfrastruktur.
            </p>

            <ul className="mt-10 grid grid-cols-1 sm:grid-cols-2 gap-x-8 gap-y-4">
              {MAST_FEATURES.map((f, i) => (
                <li
                  key={f}
                  data-testid={`mast-feature-${i}`}
                  className="flex items-start gap-3 text-slate-700"
                >
                  <span className="mt-0.5 inline-flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-[#0055A4]/10 text-[#0055A4]">
                    <Check className="h-3 w-3" strokeWidth={3} />
                  </span>
                  <span className="text-sm leading-relaxed">{f}</span>
                </li>
              ))}
            </ul>

            <div className="mt-12 border-t border-slate-200 pt-8">
              <p className="font-mono-tech text-xs uppercase tracking-[0.25em] text-slate-400 mb-4">
                Ideal für
              </p>
              <div className="flex flex-wrap gap-2">
                {MAST_USE_CASES.map((u) => (
                  <span
                    key={u}
                    data-testid={`mast-usecase-${u}`}
                    className="inline-flex items-center gap-2 px-3.5 py-1.5 text-sm bg-slate-100 text-slate-700 rounded-full border border-slate-200 hover:border-[#0055A4] hover:text-[#0055A4] transition-colors"
                  >
                    {u}
                  </span>
                ))}
              </div>
            </div>
          </div>

          <div className="lg:col-span-5">
            <div
              data-testid="mast-visual"
              className="relative rounded-2xl overflow-hidden bg-gradient-to-b from-slate-100 to-slate-50 border border-slate-200 aspect-[4/5] min-h-[420px]"
            >
              <img
                src={IMG.mastDetail}
                alt="Xortec Kameramast – technisches Detail"
                className="absolute inset-0 h-full w-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-[#0B1220]/60 via-transparent to-transparent" />
              <div className="absolute bottom-0 left-0 right-0 p-6">
                <div className="bg-white/95 backdrop-blur-sm rounded-lg p-5 border border-white/60 shadow-lg">
                  <div className="flex items-center justify-between">
                    <div>
                      <div className="font-mono-tech text-[10px] text-slate-400 tracking-widest">
                        SPEC · ALU
                      </div>
                      <div className="font-display text-base font-semibold text-slate-900">
                        Aluminium · pulverbeschichtet
                      </div>
                    </div>
                    <div className="text-right">
                      <div className="font-mono-tech text-[10px] text-slate-400 tracking-widest">
                        HÖHEN
                      </div>
                      <div className="font-display text-base font-semibold text-slate-900">
                        4 – 12 m
                      </div>
                    </div>
                  </div>
                  <div className="mt-4 grid grid-cols-3 gap-3 text-center">
                    <div>
                      <div className="font-display text-lg font-semibold text-[#0055A4]">
                        IP66
                      </div>
                      <div className="text-[10px] text-slate-500 uppercase tracking-wider">
                        Schutz
                      </div>
                    </div>
                    <div>
                      <div className="font-display text-lg font-semibold text-[#0055A4]">
                        25+
                      </div>
                      <div className="text-[10px] text-slate-500 uppercase tracking-wider leading-tight">
                        Jahre
                        <br />
                        Haltbarkeit
                      </div>
                    </div>
                    <div>
                      <div className="font-display text-lg font-semibold text-[#0055A4]">
                        Modular
                      </div>
                      <div className="text-[10px] text-slate-500 uppercase tracking-wider">
                        Aufbau
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
